import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { CoverageZonesApiAdapter } from '../adapters/CoverageZonesApiAdapter';
import { Service } from '../services/Service';

interface UseCourierServicesOptions {
    courierId: string;
    enabled?: boolean; // Permite controlar cuándo se ejecuta la query
}

export const useCourierServices = ({ courierId, enabled = true }: UseCourierServicesOptions) => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CoverageZonesApiAdapter(httpClient);
    const service = new Service(apiAdapter);

    const { data, isLoading, error, refetch, isPending } = useQuery({
        queryKey: ['courier-services', courierId],
        queryFn: () => service.getCourierServices(courierId),
        enabled: enabled && !!courierId, // Solo ejecutar si está habilitado y hay courierId
        staleTime: 5 * 60 * 1000, // 5 minutos
    });

    return {
        services: data ?? [],
        isLoading: isLoading || isPending,
        error,
        refetch,
        total: data?.length ?? 0,
    };
};

